import { ProductTypeEnum } from "@/types/ProductType";
import { ProductTypeMeetingEditFlowTab } from "./ProductTypeMeetingEditFlowTab";
import { ProductTypeTrackEditFlowTab } from "./ProductTypeTrackEditFlowTab";

type MeetingCheckoutOnSuccessAction =
  | { type: "GoTo"; route: string }
  | { type: "StartAutomation"; automationId: string };

export function ProductEditFlowTab({
  productId,
  productType,
  startPageId,
  accessOnSuccessActions,
  shopOnSuccessActions,
  onFlowChange,
}: {
  productId: string;
  productType?: string;
  startPageId?: string;
  accessOnSuccessActions?: MeetingCheckoutOnSuccessAction[];
  shopOnSuccessActions?: MeetingCheckoutOnSuccessAction[];
  onFlowChange?: () => void;
}) {
  if (productType === ProductTypeEnum.TRACK) {
    return (
      <ProductTypeTrackEditFlowTab
        productId={productId}
        startPageId={startPageId}
        onFlowChange={onFlowChange}
      />
    );
  }

  if (productType === ProductTypeEnum.MEETING) {
    return (
      <ProductTypeMeetingEditFlowTab
        productId={productId}
        accessOnSuccessActions={accessOnSuccessActions}
        shopOnSuccessActions={shopOnSuccessActions}
        onFlowChange={onFlowChange}
      />
    );
  }

  return null;
}
